<template>
    <div class="evolt-notification mt-3" style="margin-bottom: 2px;">
        <p v-if="!evolt_error">It looks like you haven’t completed your Evolt Body Scan. Speak to your studio manager as soon as possible
            to arrange. You must have Evolt Body Scans to be eligible for judging.</p>
        <p v-if="evolt_error">{{ evolt_error }}</p>
    </div>
</template>

<script>

    import { mapState } from 'vuex'

    export default {
        name: "EvoltNotification",
        computed: {
            ...mapState({
                cutoff_date: state => state.challenge.challenge.cutoff_date,
                evolt_error: state => state.data.evolt_error
            })
        }
    }
</script>

<style scoped lang="scss">
    .evolt-notification {
        background: #000000;
        padding: 40px;
        p {
            color: #FFFFFF;
            font-size: 16px;
            margin: 0;
            text-align: center;
        }
    }
</style>
